import { Dispatch } from 'react';
import { actionTypes } from '../../../../types';

export default function CheckBoxCell({
  dispatch,
  state,
  iri,
}: {
  dispatch: Dispatch<any>;
  state: any;
  iri: string;
}) {
  if (iri === '') {
    return <input type="checkbox" disabled />;
  }

  return (
    <input
      type="checkbox"
      checked={state.rowChecked.includes(iri)}
      onChange={e => {
        const { checked } = e.target;
        if (checked) {
          dispatch({ type: actionTypes.SET_CHECK, payload: iri });
        } else {
          dispatch({ type: actionTypes.UNCHECK, payload: iri });
        }
      }}
      onClick={e => e.stopPropagation()}
    />
  );
}
